/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class SecurityValuesGrid extends SiteEntityGrid<SecurityValueRow, any> {
        protected getColumnsKey() { return 'Data.SecurityValue'; }
        protected getDialogType() { return SecurityValueDialog; }
        protected getIdProperty() { return SecurityValueRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityValueRow.localTextPrefix; }
        protected getService() { return SecurityValueService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected getColumns() {
            return super.getColumns().filter(x => x.field != SecurityValueRow.Fields.SecurityId);
        }

        protected getGridCanLoad() {
            return !!this._securityId;
        }

        private _securityId: number;

        public get securityId() {
            return this._securityId;
        }

        public set securityId(value: number) {
            if (this._securityId != value) {
                this._securityId = value;
                this.setEquality(SecurityValueRow.Fields.SecurityId, value);
                this.refresh();
            }
        }
    }
}